// Custom Scripts - bundled by gulp (fileinclude)
/*
 * Bread Units Calculator - food reference data
 * -------------------------------------------------
 * `carbs` = approximate grams of carbohydrates per 100 g of the product.
 * Rounded reference figures from commonly published food-composition and
 * bread-unit tables (incl. the Sanofi "Таблиця хлібних одиниць", 2024).
 * Estimates for informational use only.
 *
 * `gi` = approximate glycemic index (glucose scale, 0-100+). Rounded figures
 * from public GI databases (University of Sydney, USDA and similar). GI varies
 * widely with variety, ripeness and preparation, so treat these as a rough
 * band only. Omitted for foods with negligible carbohydrate, where GI has
 * little practical meaning.
 *   low <= 55   |   medium 56-69   |   high >= 70
 *
 * The calculator keeps the original project formula:
 *     XE = (carbs / 100) * weight / norm      (norm = 10 or 12)
 *
 * Selecting a food only pre-fills the "carbohydrates per 100 g" field;
 * the user can still type any value manually.
 *
 * `piece` (optional) = typical weight of one piece, in grams.
 * `liquid` = true -> measured in millilitres.
 */
window.BUC_FOODS = [
  // ---------- Bread & Bakery ----------
  { id: "white-bread",      cat: "bakery",  carbs: 49, gi: 75, name: { uk: "Білий хліб",              en: "White bread",              es: "Pan blanco" } },
  { id: "rye-bread",        cat: "bakery",  carbs: 42, gi: 58, name: { uk: "Житній хліб",             en: "Rye bread",                es: "Pan de centeno" } },
  { id: "borodino-bread",   cat: "bakery",  carbs: 40, gi: 65, name: { uk: "Бородінський хліб",       en: "Borodinsky bread",         es: "Pan Borodinsky" } },
  { id: "bran-bread",       cat: "bakery",  carbs: 40, gi: 55, name: { uk: "Хліб із висівками",       en: "Bran bread",               es: "Pan de salvado" } },
  { id: "rusks",            cat: "bakery",  carbs: 70, gi: 70, name: { uk: "Сухарі",                  en: "Rusks / dried bread",      es: "Pan tostado seco" } },
  { id: "crispbread",       cat: "bakery",  carbs: 75, gi: 65, name: { uk: "Хлібці хрусткі",          en: "Crispbread",               es: "Pan crujiente" } },
  { id: "crackers",         cat: "bakery",  carbs: 68, gi: 70, name: { uk: "Крекери несолодкі",       en: "Plain crackers",           es: "Galletas saladas" } },
  { id: "bread-sticks",     cat: "bakery",  carbs: 72, gi: 70, name: { uk: "Хлібні палички",          en: "Bread sticks",             es: "Palitos de pan" } },
  { id: "bagel",            cat: "bakery",  carbs: 56, gi: 72, piece: 50,  name: { uk: "Бублик",       en: "Bagel",                    es: "Bagel" } },
  { id: "lavash",           cat: "bakery",  carbs: 47, gi: 68, name: { uk: "Лаваш",                   en: "Lavash flatbread",         es: "Pan de lavash" } },
  { id: "wheat-flour",      cat: "bakery",  carbs: 73, gi: 70, name: { uk: "Борошно пшеничне",        en: "Wheat flour",              es: "Harina de trigo" } },
  { id: "breadcrumbs",      cat: "bakery",  carbs: 72, gi: 74, name: { uk: "Панірувальні сухарі",     en: "Breadcrumbs",              es: "Pan rallado" } },
  { id: "puff-pastry",      cat: "bakery",  carbs: 34, gi: 55, name: { uk: "Листкове тісто",          en: "Puff pastry (raw)",        es: "Masa de hojaldre" } },
  { id: "yeast-dough",      cat: "bakery",  carbs: 43, gi: 60, name: { uk: "Дріжджове тісто",         en: "Yeast dough (raw)",        es: "Masa de levadura" } },
  { id: "pancake",          cat: "bakery",  carbs: 28, gi: 66, piece: 40,  name: { uk: "Млинець",      en: "Thin pancake",             es: "Panqueque" } },
  { id: "oladki",           cat: "bakery",  carbs: 33, gi: 62, piece: 30,  name: { uk: "Оладки",       en: "Thick pancakes (oladki)",  es: "Tortitas gruesas" } },
  { id: "dumplings-curd",   cat: "bakery",  carbs: 19, gi: 55, piece: 13,  name: { uk: "Вареники з сиром", en: "Curd dumplings",       es: "Vareniki de requesón" } },
  { id: "pelmeni",          cat: "bakery",  carbs: 22, gi: 55, piece: 13,  name: { uk: "Пельмені",     en: "Pelmeni (meat dumplings)", es: "Pelmeni (empanadillas)" } },
  { id: "vatrushka",        cat: "bakery",  carbs: 40, gi: 60, piece: 50,  name: { uk: "Ватрушка",     en: "Vatrushka (curd bun)",     es: "Bollo de requesón" } },
  { id: "raisin-bun",       cat: "bakery",  carbs: 47, gi: 65, piece: 25,  name: { uk: "Булочка з родзинками", en: "Raisin bun",       es: "Bollo con pasas" } },
  { id: "gingerbread",      cat: "bakery",  carbs: 74, gi: 65, piece: 40,  name: { uk: "Пряник",       en: "Gingerbread",              es: "Pan de jengibre" } },
  { id: "waffles",          cat: "bakery",  carbs: 65, gi: 76, name: { uk: "Вафлі",                   en: "Waffles",                  es: "Barquillos" } },
  { id: "butter-cookies",   cat: "bakery",  carbs: 66, gi: 55, name: { uk: "Печиво вершкове",         en: "Butter cookies",           es: "Galletas de mantequilla" } },
  { id: "muesli",           cat: "bakery",  carbs: 62, gi: 57, name: { uk: "Мюслі без цукру",         en: "Muesli (no sugar)",        es: "Muesli sin azúcar" } },
  { id: "cornflakes",       cat: "bakery",  carbs: 83, gi: 81, name: { uk: "Кукурудзяні пластівці",   en: "Cornflakes",               es: "Copos de maíz" } },
  { id: "wheat-bran",       cat: "bakery",  carbs: 22, gi: 43, name: { uk: "Пшеничні висівки",        en: "Wheat bran",               es: "Salvado de trigo" } },
  { id: "popcorn",          cat: "bakery",  carbs: 78, gi: 65, name: { uk: "Попкорн без цукру",       en: "Popcorn (unsweetened)",    es: "Palomitas sin azúcar" } },

  // ---------- Cereals ----------
  { id: "buckwheat-dry",    cat: "cereals", carbs: 62, gi: 50, name: { uk: "Гречка (сухою вагою)",    en: "Buckwheat (dry)",     es: "Trigo sarraceno (seco)" } },
  { id: "rice-dry",         cat: "cereals", carbs: 74, gi: 70, name: { uk: "Рис (сухою вагою)",       en: "Rice (dry)",          es: "Arroz (seco)" } },
  { id: "rice-cooked",      cat: "cereals", carbs: 25, gi: 70, name: { uk: "Рис відварений",          en: "Rice (cooked)",       es: "Arroz (cocido)" } },
  { id: "oatmeal-dry",      cat: "cereals", carbs: 60, gi: 55, name: { uk: "Вівсянка (сухою вагою)",  en: "Oatmeal (dry)",       es: "Avena (seca)" } },
  { id: "semolina-dry",     cat: "cereals", carbs: 70, gi: 65, name: { uk: "Манка (сухою вагою)",     en: "Semolina (dry)",      es: "Sémola (seca)" } },
  { id: "millet-dry",       cat: "cereals", carbs: 66, gi: 70, name: { uk: "Пшоно (сухою вагою)",     en: "Millet (dry)",        es: "Mijo (seco)" } },
  { id: "barley-dry",       cat: "cereals", carbs: 67, gi: 28, name: { uk: "Перловка (сухою вагою)",  en: "Pearl barley (dry)",  es: "Cebada perlada (seca)" } },
  { id: "porridge-cooked",  cat: "cereals", carbs: 15, gi: 60, name: { uk: "Каша (варена)",           en: "Porridge (cooked)",   es: "Gachas (cocidas)" } },
  { id: "starch",           cat: "cereals", carbs: 85, gi: 85, name: { uk: "Крохмаль",                en: "Starch",              es: "Almidón" } },
  { id: "sprouted-grain",   cat: "cereals", carbs: 31, gi: 45, name: { uk: "Пророщене зерно",         en: "Sprouted grain",      es: "Grano germinado" } },
  { id: "corn-cob",         cat: "cereals", carbs: 22, gi: 52, piece: 250, name: { uk: "Кукурудза (качан)", en: "Corn on the cob",  es: "Mazorca de maíz" } },
  { id: "corn-boiled",      cat: "cereals", carbs: 21, gi: 52, name: { uk: "Кукурудза варена",        en: "Corn (boiled)",       es: "Maíz (cocido)" } },
  { id: "corn-canned",      cat: "cereals", carbs: 20, gi: 55, name: { uk: "Кукурудза консервована",  en: "Sweet corn (canned)", es: "Maíz dulce (lata)" } },

  // ---------- Pasta & Potatoes ----------
  { id: "pasta-dry",        cat: "pasta",   carbs: 71, gi: 50, name: { uk: "Макарони (сухою вагою)",  en: "Pasta (dry)",         es: "Pasta (seca)" } },
  { id: "pasta-cooked",     cat: "pasta",   carbs: 25, gi: 50, name: { uk: "Макарони відварені",      en: "Pasta (cooked)",      es: "Pasta (cocida)" } },
  { id: "potato-raw",       cat: "pasta",   carbs: 17, piece: 90,  name: { uk: "Картопля сира", en: "Potato (raw)",       es: "Papa (cruda)" } },
  { id: "potato-boiled",    cat: "pasta",   carbs: 16, gi: 78, name: { uk: "Картопля відварена",      en: "Boiled potato",       es: "Papa hervida" } },
  { id: "potato-jacket",    cat: "pasta",   carbs: 16, gi: 75, piece: 75,  name: { uk: "Картопля в мундирі", en: "Jacket potato",   es: "Papa con piel" } },
  { id: "mashed-potato",    cat: "pasta",   carbs: 14, gi: 83, name: { uk: "Картопляне пюре",         en: "Mashed potato",       es: "Puré de papa" } },
  { id: "fried-potato",     cat: "pasta",   carbs: 30, gi: 75, name: { uk: "Смажена картопля",        en: "Fried potato",        es: "Papa frita" } },
  { id: "french-fries",     cat: "pasta",   carbs: 34, gi: 63, piece: 115, name: { uk: "Картопля фрі",  en: "French fries",        es: "Papas fritas" } },
  { id: "potato-pancakes",  cat: "pasta",   carbs: 20, gi: 75, name: { uk: "Деруни (картопляні оладки)", en: "Potato pancakes", es: "Tortitas de papa" } },
  { id: "potato-chips",     cat: "pasta",   carbs: 50, gi: 56, name: { uk: "Картопляні чіпси",        en: "Potato chips",        es: "Papas fritas de bolsa" } },

  // ---------- Vegetables ----------
  { id: "carrot",           cat: "veggies", carbs: 7,  gi: 39, piece: 75,  name: { uk: "Морква",       en: "Carrot",              es: "Zanahoria" } },
  { id: "beetroot",         cat: "veggies", carbs: 9,  gi: 64, piece: 130, name: { uk: "Буряк",        en: "Beetroot",            es: "Remolacha" } },
  { id: "pumpkin",          cat: "veggies", carbs: 6,  gi: 75, name: { uk: "Гарбуз",                  en: "Pumpkin",             es: "Calabaza" } },
  { id: "jerusalem-artichoke", cat: "veggies", carbs: 13, gi: 50, name: { uk: "Топінамбур",           en: "Jerusalem artichoke", es: "Tupinambo" } },
  { id: "sauerkraut",       cat: "veggies", carbs: 3,  name: { uk: "Квашена капуста",         en: "Sauerkraut",          es: "Chucrut" } },
  { id: "cauliflower",      cat: "veggies", carbs: 4,  name: { uk: "Цвітна капуста",          en: "Cauliflower",         es: "Coliflor" } },
  { id: "white-cabbage",    cat: "veggies", carbs: 5,  name: { uk: "Білокачанна капуста",     en: "White cabbage",       es: "Col blanca" } },
  { id: "red-cabbage",      cat: "veggies", carbs: 6,  name: { uk: "Червонокачанна капуста",  en: "Red cabbage",         es: "Col lombarda" } },
  { id: "brussels-sprouts", cat: "veggies", carbs: 6,  name: { uk: "Брюссельська капуста",    en: "Brussels sprouts",    es: "Coles de Bruselas" } },
  { id: "bell-pepper",      cat: "veggies", carbs: 5,  piece: 120, name: { uk: "Болгарський перець", en: "Bell pepper",     es: "Pimiento" } },
  { id: "cucumber",         cat: "veggies", carbs: 2,  name: { uk: "Огірки",                  en: "Cucumber",            es: "Pepino" } },
  { id: "tomato",           cat: "veggies", carbs: 3,  name: { uk: "Помідори",                en: "Tomato",              es: "Tomate" } },
  { id: "radish",           cat: "veggies", carbs: 3,  name: { uk: "Редис",                   en: "Radish",              es: "Rábano" } },
  { id: "spinach",          cat: "veggies", carbs: 2,  name: { uk: "Шпинат",                  en: "Spinach",             es: "Espinaca" } },

  // ---------- Legumes ----------
  { id: "green-peas",       cat: "legumes", carbs: 13, gi: 48, name: { uk: "Горошок зелений",         en: "Green peas",          es: "Guisantes verdes" } },
  { id: "beans-dry",        cat: "legumes", carbs: 55, gi: 35, name: { uk: "Квасоля (сухою вагою)",   en: "Beans (dry)",         es: "Frijoles (secos)" } },
  { id: "beans-boiled",     cat: "legumes", carbs: 22, gi: 30, name: { uk: "Квасоля відварена",       en: "Beans (boiled)",      es: "Frijoles (cocidos)" } },
  { id: "lentils-dry",      cat: "legumes", carbs: 57, gi: 30, name: { uk: "Сочевиця (сухою вагою)",  en: "Lentils (dry)",       es: "Lentejas (secas)" } },
  { id: "lentils-boiled",   cat: "legumes", carbs: 20, gi: 30, name: { uk: "Сочевиця відварена",      en: "Lentils (boiled)",    es: "Lentejas (cocidas)" } },
  { id: "chickpeas-dry",    cat: "legumes", carbs: 57, gi: 30, name: { uk: "Нут (сухою вагою)",       en: "Chickpeas (dry)",     es: "Garbanzos (secos)" } },
  { id: "soybeans-dry",     cat: "legumes", carbs: 20, gi: 16, name: { uk: "Соя (сухою вагою)",       en: "Soybeans (dry)",      es: "Soja (seca)" } },

  // ---------- Fruits & Berries ----------
  { id: "apple",            cat: "fruits",  carbs: 11, gi: 35, piece: 150, name: { uk: "Яблуко",       en: "Apple",               es: "Manzana" } },
  { id: "pear",             cat: "fruits",  carbs: 10, gi: 38, piece: 135, name: { uk: "Груша",        en: "Pear",                es: "Pera" } },
  { id: "quince",           cat: "fruits",  carbs: 10, gi: 35, piece: 140, name: { uk: "Айва",         en: "Quince",              es: "Membrillo" } },
  { id: "banana",           cat: "fruits",  carbs: 21, gi: 51, piece: 120, name: { uk: "Банан",        en: "Banana",              es: "Plátano" } },
  { id: "orange",           cat: "fruits",  carbs: 8,  gi: 43, piece: 180, name: { uk: "Апельсин",     en: "Orange",              es: "Naranja" } },
  { id: "tangerine",        cat: "fruits",  carbs: 8,  gi: 45, piece: 70,  name: { uk: "Мандарин",     en: "Tangerine",           es: "Mandarina" } },
  { id: "grapefruit",       cat: "fruits",  carbs: 7,  gi: 25, piece: 350, name: { uk: "Грейпфрут",    en: "Grapefruit",          es: "Pomelo" } },
  { id: "lemon",            cat: "fruits",  carbs: 3,  gi: 20, piece: 90,  name: { uk: "Лимон",        en: "Lemon",               es: "Limón" } },
  { id: "pomegranate",      cat: "fruits",  carbs: 14, gi: 35, piece: 200, name: { uk: "Гранат",       en: "Pomegranate",         es: "Granada" } },
  { id: "grapes",           cat: "fruits",  carbs: 16, gi: 46, name: { uk: "Виноград",                en: "Grapes",              es: "Uvas" } },
  { id: "watermelon",       cat: "fruits",  carbs: 8,  gi: 72, name: { uk: "Кавун",                   en: "Watermelon",          es: "Sandía" } },
  { id: "melon",            cat: "fruits",  carbs: 8,  gi: 65, name: { uk: "Диня",                    en: "Melon",               es: "Melón" } },
  { id: "pineapple",        cat: "fruits",  carbs: 12, gi: 59, name: { uk: "Ананас",                  en: "Pineapple",           es: "Piña" } },
  { id: "mango",            cat: "fruits",  carbs: 15, gi: 51, piece: 200, name: { uk: "Манго",        en: "Mango",               es: "Mango" } },
  { id: "papaya",           cat: "fruits",  carbs: 11, gi: 59, name: { uk: "Папайя",                  en: "Papaya",              es: "Papaya" } },
  { id: "kiwi",             cat: "fruits",  carbs: 10, gi: 50, piece: 75,  name: { uk: "Ківі",         en: "Kiwi",                es: "Kiwi" } },
  { id: "peach",            cat: "fruits",  carbs: 10, gi: 42, piece: 120, name: { uk: "Персик",       en: "Peach",               es: "Durazno" } },
  { id: "nectarine",        cat: "fruits",  carbs: 12, gi: 43, piece: 120, name: { uk: "Нектарин",     en: "Nectarine",           es: "Nectarina" } },
  { id: "apricot",          cat: "fruits",  carbs: 9,  gi: 34, piece: 30,  name: { uk: "Абрикос",      en: "Apricot",             es: "Albaricoque" } },
  { id: "plum",             cat: "fruits",  carbs: 11, gi: 39, piece: 40,  name: { uk: "Слива",        en: "Plum",                es: "Ciruela" } },
  { id: "cherry-plum",      cat: "fruits",  carbs: 8,  gi: 25, name: { uk: "Алича",                   en: "Cherry plum",         es: "Ciruela mirabel" } },
  { id: "persimmon",        cat: "fruits",  carbs: 17, gi: 50, piece: 170, name: { uk: "Хурма",        en: "Persimmon",           es: "Caqui" } },
  { id: "fig-fresh",        cat: "fruits",  carbs: 16, gi: 35, piece: 50,  name: { uk: "Інжир свіжий", en: "Fig (fresh)",         es: "Higo (fresco)" } },
  { id: "avocado",          cat: "fruits",  carbs: 6,  piece: 200, name: { uk: "Авокадо",      en: "Avocado",             es: "Aguacate" } },
  { id: "cherry",           cat: "fruits",  carbs: 13, gi: 22, name: { uk: "Черешня",                 en: "Sweet cherry",        es: "Cereza" } },
  { id: "sour-cherry",      cat: "fruits",  carbs: 11, gi: 22, name: { uk: "Вишня",                   en: "Sour cherry",         es: "Guinda" } },
  { id: "strawberry",       cat: "fruits",  carbs: 7,  gi: 40, name: { uk: "Полуниця",                en: "Strawberry",          es: "Fresa" } },
  { id: "raspberry",        cat: "fruits",  carbs: 8,  gi: 32, name: { uk: "Малина",                  en: "Raspberry",           es: "Frambuesa" } },
  { id: "blackberry",       cat: "fruits",  carbs: 10, gi: 25, name: { uk: "Ожина",                   en: "Blackberry",          es: "Mora" } },
  { id: "blueberry",        cat: "fruits",  carbs: 8,  gi: 53, name: { uk: "Чорниця",                 en: "Blueberry",           es: "Arándano" } },
  { id: "lingonberry",      cat: "fruits",  carbs: 8,  gi: 25, name: { uk: "Брусниця",                en: "Lingonberry",         es: "Arándano rojo" } },
  { id: "cranberry",        cat: "fruits",  carbs: 8,  gi: 45, name: { uk: "Журавлина",               en: "Cranberry",           es: "Arándano agrio" } },
  { id: "gooseberry",       cat: "fruits",  carbs: 10, gi: 25, name: { uk: "Аґрус",                   en: "Gooseberry",          es: "Grosella espinosa" } },
  { id: "blackcurrant",     cat: "fruits",  carbs: 8,  gi: 15, name: { uk: "Чорна смородина",         en: "Blackcurrant",        es: "Grosella negra" } },
  { id: "redcurrant",       cat: "fruits",  carbs: 8,  gi: 25, name: { uk: "Червона смородина",       en: "Redcurrant",          es: "Grosella roja" } },
  { id: "feijoa",           cat: "fruits",  carbs: 13, gi: 35, name: { uk: "Фейхоа",                  en: "Feijoa",              es: "Feijoa" } },
  { id: "dried-apricots",   cat: "fruits",  carbs: 62, gi: 30, name: { uk: "Курага",                  en: "Dried apricots",      es: "Orejones" } },
  { id: "prunes",           cat: "fruits",  carbs: 60, gi: 40, name: { uk: "Чорнослив",               en: "Prunes",              es: "Ciruelas pasas" } },
  { id: "raisins",          cat: "fruits",  carbs: 72, gi: 65, name: { uk: "Родзинки",                en: "Raisins",             es: "Pasas" } },
  { id: "dates",            cat: "fruits",  carbs: 69, gi: 62, piece: 8, name: { uk: "Фініки",         en: "Dates",               es: "Dátiles" } },
  { id: "dried-figs",       cat: "fruits",  carbs: 58, gi: 61, name: { uk: "Інжир сушений",           en: "Dried figs",          es: "Higos secos" } },
  { id: "dried-apple",      cat: "fruits",  carbs: 59, gi: 41, name: { uk: "Яблука сушені",           en: "Dried apple",         es: "Manzana seca" } },

  // ---------- Juices ----------
  { id: "orange-juice",     cat: "juices",  carbs: 11, gi: 50, liquid: true, name: { uk: "Апельсиновий сік", en: "Orange juice",     es: "Zumo de naranja" } },
  { id: "apple-juice",      cat: "juices",  carbs: 11, gi: 41, liquid: true, name: { uk: "Яблучний сік",     en: "Apple juice",      es: "Zumo de manzana" } },
  { id: "grape-juice",      cat: "juices",  carbs: 14, gi: 55, liquid: true, name: { uk: "Виноградний сік",  en: "Grape juice",      es: "Zumo de uva" } },
  { id: "cherry-juice",     cat: "juices",  carbs: 12, gi: 40, liquid: true, name: { uk: "Вишневий сік",     en: "Cherry juice",     es: "Zumo de cereza" } },
  { id: "pear-juice",       cat: "juices",  carbs: 10, gi: 44, liquid: true, name: { uk: "Грушевий сік",     en: "Pear juice",       es: "Zumo de pera" } },
  { id: "plum-juice",       cat: "juices",  carbs: 12, gi: 45, liquid: true, name: { uk: "Сливовий сік",     en: "Plum juice",       es: "Zumo de ciruela" } },
  { id: "grapefruit-juice", cat: "juices",  carbs: 8,  gi: 48, liquid: true, name: { uk: "Грейпфрутовий сік", en: "Grapefruit juice", es: "Zumo de pomelo" } },
  { id: "carrot-juice",     cat: "juices",  carbs: 8,  gi: 43, liquid: true, name: { uk: "Морквяний сік",    en: "Carrot juice",     es: "Zumo de zanahoria" } },
  { id: "beet-juice",       cat: "juices",  carbs: 8,  gi: 64, liquid: true, name: { uk: "Буряковий сік",    en: "Beetroot juice",   es: "Zumo de remolacha" } },
  { id: "tomato-juice",     cat: "juices",  carbs: 3,  gi: 38, liquid: true, name: { uk: "Томатний сік",     en: "Tomato juice",     es: "Zumo de tomate" } },

  // ---------- Dairy ----------
  { id: "milk",             cat: "dairy",   carbs: 5,  gi: 39, liquid: true, name: { uk: "Молоко",          en: "Milk",             es: "Leche" } },
  { id: "baked-milk",       cat: "dairy",   carbs: 5,  gi: 40, liquid: true, name: { uk: "Молоко пряжене",  en: "Baked milk",       es: "Leche horneada" } },
  { id: "kefir",            cat: "dairy",   carbs: 4,  gi: 25, liquid: true, name: { uk: "Кефір",           en: "Kefir",            es: "Kéfir" } },
  { id: "ryazhanka",        cat: "dairy",   carbs: 4,  gi: 30, liquid: true, name: { uk: "Ряжанка",         en: "Ryazhanka (fermented baked milk)", es: "Leche horneada fermentada" } },
  { id: "soured-milk",      cat: "dairy",   carbs: 4,  gi: 30, liquid: true, name: { uk: "Кисле молоко",    en: "Soured milk",      es: "Leche cortada" } },
  { id: "buttermilk",       cat: "dairy",   carbs: 4,  gi: 30, liquid: true, name: { uk: "Маслянка",        en: "Buttermilk",       es: "Suero de mantequilla" } },
  { id: "cream",            cat: "dairy",   carbs: 4,  gi: 30, liquid: true, name: { uk: "Вершки",          en: "Cream",            es: "Nata" } },
  { id: "plain-yogurt",     cat: "dairy",   carbs: 6,  gi: 35, liquid: true, name: { uk: "Йогурт без цукру", en: "Plain yogurt",    es: "Yogur natural" } },
  { id: "fruit-yogurt",     cat: "dairy",   carbs: 14, gi: 41, name: { uk: "Йогурт фруктовий",        en: "Fruit yogurt",        es: "Yogur de frutas" } },
  { id: "condensed-milk",   cat: "dairy",   carbs: 9,  gi: 45, name: { uk: "Згущене молоко без цукру", en: "Condensed milk (unsweetened)", es: "Leche condensada sin azúcar" } },
  { id: "milk-powder",      cat: "dairy",   carbs: 50, gi: 46, name: { uk: "Сухе молоко",             en: "Milk powder",         es: "Leche en polvo" } },
  { id: "sweet-curd-mass",  cat: "dairy",   carbs: 15, gi: 55, name: { uk: "Сирна маса солодка",      en: "Sweet curd mass",     es: "Requesón dulce" } },
  { id: "glazed-curd-bar",  cat: "dairy",   carbs: 30, gi: 55, piece: 40, name: { uk: "Сирок глазурований", en: "Glazed curd bar", es: "Barrita de requesón glaseada" } },
  { id: "syrnik",           cat: "dairy",   carbs: 22, gi: 50, piece: 75, name: { uk: "Сирник",         en: "Syrnik (curd fritter)", es: "Buñuelo de requesón" } },
  { id: "ice-cream",        cat: "dairy",   carbs: 23, gi: 60, name: { uk: "Морозиво",                en: "Ice cream",           es: "Helado" } },

  // ---------- Nuts ----------
  { id: "walnuts",          cat: "nuts",    carbs: 11, gi: 15, name: { uk: "Волоські горіхи",         en: "Walnuts",             es: "Nueces" } },
  { id: "peanuts",          cat: "nuts",    carbs: 16, gi: 15, name: { uk: "Арахіс",                  en: "Peanuts",             es: "Cacahuetes" } },
  { id: "pine-nuts",        cat: "nuts",    carbs: 13, gi: 15, name: { uk: "Кедрові горіхи",          en: "Pine nuts",           es: "Piñones" } },
  { id: "cashew",           cat: "nuts",    carbs: 27, gi: 25, name: { uk: "Кеш'ю",                   en: "Cashews",             es: "Anacardos" } },
  { id: "almonds",          cat: "nuts",    carbs: 13, gi: 15, name: { uk: "Мигдаль",                 en: "Almonds",             es: "Almendras" } },
  { id: "pistachios",       cat: "nuts",    carbs: 28, gi: 20, name: { uk: "Фісташки",               en: "Pistachios",          es: "Pistachos" } },
  { id: "hazelnuts",        cat: "nuts",    carbs: 17, gi: 15, name: { uk: "Фундук",                  en: "Hazelnuts",           es: "Avellanas" } },

  // ---------- Ready meals & fast food ----------
  { id: "hamburger",        cat: "fastfood", carbs: 30, gi: 66, piece: 100, name: { uk: "Гамбургер",   en: "Hamburger",           es: "Hamburguesa" } },
  { id: "cheeseburger",     cat: "fastfood", carbs: 30, gi: 66, piece: 105, name: { uk: "Чізбургер",   en: "Cheeseburger",        es: "Hamburguesa con queso" } },
  { id: "big-mac",          cat: "fastfood", carbs: 20, gi: 70, piece: 215, name: { uk: "Біг Мак",     en: "Big Mac",             es: "Big Mac" } },
  { id: "chicken-nuggets",  cat: "fastfood", carbs: 16, gi: 46, piece: 100, name: { uk: "Курячі нагетси", en: "Chicken nuggets",  es: "Nuggets de pollo" } },
  { id: "pizza",            cat: "fastfood", carbs: 25, gi: 60, piece: 300, name: { uk: "Піца",        en: "Pizza",               es: "Pizza" } },
  { id: "bean-burrito",     cat: "fastfood", carbs: 25, gi: 55, piece: 220, name: { uk: "Буріто з квасолею", en: "Bean burrito",  es: "Burrito de frijoles" } },
  { id: "cutlet",           cat: "fastfood", carbs: 10, gi: 50, piece: 90,  name: { uk: "Котлета",     en: "Cutlet (breaded)",    es: "Filete empanado" } },
  { id: "cake-slice",       cat: "fastfood", carbs: 45, gi: 55, piece: 100, name: { uk: "Торт / пиріг", en: "Cake / pie",         es: "Tarta / pastel" } },

  // ---------- Other foods ----------
  { id: "sugar",            cat: "other",   carbs: 100, gi: 65, name: { uk: "Цукор",                  en: "Sugar",               es: "Azúcar" } },
  { id: "fructose",         cat: "other",   carbs: 100, gi: 20, name: { uk: "Фруктоза",               en: "Fructose",            es: "Fructosa" } },
  { id: "honey",            cat: "other",   carbs: 80, gi: 55, name: { uk: "Мед",                     en: "Honey",               es: "Miel" } },
  { id: "jam",              cat: "other",   carbs: 70, gi: 55, name: { uk: "Варення",                 en: "Jam",                 es: "Mermelada" } },
  { id: "marmalade",        cat: "other",   carbs: 77, gi: 65, name: { uk: "Мармелад",               en: "Marmalade sweets",    es: "Gominolas de mermelada" } },
  { id: "caramel",          cat: "other",   carbs: 90, gi: 70, name: { uk: "Карамель",               en: "Caramel / hard candy", es: "Caramelo duro" } },
  { id: "chocolate",        cat: "other",   carbs: 55, gi: 45, name: { uk: "Шоколад",                 en: "Chocolate",           es: "Chocolate" } },
  { id: "chocolate-candy",  cat: "other",   carbs: 60, gi: 50, piece: 15, name: { uk: "Шоколадна цукерка", en: "Chocolate candy", es: "Bombón de chocolate" } },
  { id: "pudding",          cat: "other",   carbs: 16, gi: 45, name: { uk: "Пудинг",                  en: "Pudding",             es: "Pudín" } },
  { id: "kissel",           cat: "other",   carbs: 13, gi: 50, liquid: true, name: { uk: "Кисіль",     en: "Kissel",              es: "Kissel" } },
  { id: "compote",          cat: "other",   carbs: 14, gi: 60, liquid: true, name: { uk: "Компот",     en: "Compote (fruit drink)", es: "Compota (bebida)" } },
  { id: "kvass",            cat: "other",   carbs: 5,  gi: 45, liquid: true, name: { uk: "Квас",       en: "Kvass",               es: "Kvas" } },
  { id: "beer-light",       cat: "other",   carbs: 4,  gi: 66, liquid: true, name: { uk: "Пиво світле", en: "Light beer",         es: "Cerveza rubia" } },
  { id: "cola",             cat: "other",   carbs: 11, gi: 63, liquid: true, name: { uk: "Солодка газована вода", en: "Sugary soda", es: "Refresco azucarado" } }
];

/*
 * Bread Units Calculator - UI translations
 * Primary language: Ukrainian (uk). Also: English (en), Spanish (es).
 * Keys map to [data-i18n] (text), [data-i18n-html] (innerHTML),
 * [data-i18n-attr="attr:key,attr:key"] (attributes).
 */
window.BUC_I18N = {
  uk: {
    "meta.title": "Калькулятор хлібних одиниць (ХО) — розрахунок XE онлайн",
    "meta.description": "Безкоштовний онлайн-калькулятор хлібних одиниць (ХО / XE). Рахуйте хлібні одиниці для порцій їжі та дивіться просту таблицю продуктів.",

    "nav.calculator": "Калькулятор",
    "nav.how": "Як це працює",
    "nav.gi": "Глікемічний індекс",
    "nav.table": "Таблиця продуктів",
    "nav.faq": "Питання",
    "nav.app": "Android-додаток",
    "nav.skip": "До калькулятора",
    "nav.menu": "Меню",

    "theme.toggle": "Змінити тему",
    "lang.label": "Мова",

    "hero.eyebrow": "БЕЗКОШТОВНИЙ ОНЛАЙН-ІНСТРУМЕНТ",
    "hero.h1": "Калькулятор хлібних одиниць",
    "hero.subtitle": "Швидко й просто рахуйте хлібні одиниці (ХО / XE) для порцій їжі.",
    "hero.text": "Оберіть продукт або введіть вуглеводи вручну, вкажіть вагу порції — і отримайте приблизну кількість хлібних одиниць.",
    "hero.cta1": "Переглянути таблицю",
    "hero.badge1": "Без реєстрації",
    "hero.badge2": "Працює у браузері",
    "hero.badge3": "Додаток для Android",

    "calc.title": "Калькулятор хлібних одиниць",
    "calc.tab.food": "За продуктом",
    "calc.tab.manual": "Вручну",
    "calc.tab.aria": "Режим розрахунку",
    "calc.food": "Продукт",
    "calc.food.placeholder": "Оберіть продукт зі списку…",
    "calc.food.hint": "Для обраного продукту використовується орієнтовне довідкове значення вуглеводів.",
    "calc.carbs": "Вуглеводи в 100 г продукту",
    "calc.carbs.suffix": "г",
    "calc.weight": "Загальна вага порції",
    "calc.weight.suffix": "г / мл",
    "calc.norm": "1 ХО дорівнює",
    "calc.norm.10": "10 г",
    "calc.norm.12": "12 г",
    "calc.norm.aria": "1 ХО = грами вуглеводів",
    "calc.norm.hint": "Використовується 10 або 12 г вуглеводів на одну ХО.",
    "calc.calculate": "Порахувати",
    "calc.reset": "Скинути",
    "calc.result.caption": "Приблизна кількість хлібних одиниць для цієї порції",
    "calc.result.unit": "ХО",
    "calc.error.food": "Оберіть продукт зі списку.",
    "calc.error.carbs": "Введіть вуглеводи в межах 1–100 г.",
    "calc.error.weight": "Введіть вагу порції більше за нуль.",
    "calc.formula": "({carbs} ÷ 100) × {weight} ÷ {norm} = {result} ХО",
    "calc.gi.label": "Глікемічний індекс продукту:",

    "how.h2": "Як працює калькулятор хлібних одиниць?",
    "how.infographic.src": "/img/infographic-ua.webp",
    "how.infographic.alt": "Як працює калькулятор хлібних одиниць — інфографіка з чотирма кроками",
    "how.example.title": "Приклад розрахунку",
    "how.example.body": "Порція <strong>40 г</strong>, у продукті <strong>60 г вуглеводів на 100 г</strong>, норма ХО <strong>10–12 г</strong>: (60 ÷ 100) × 40 ÷ 12 = <strong>2.0 ХО</strong>.",

    "what.h2": "Що таке хлібна одиниця (ХО / XE)?",
    "what.p1": "Хлібна одиниця (ХО), або вуглеводна обмінна одиниця (XE, від нім. «Broteinheit»), — це умовна міра для оцінки кількості засвоюваних вуглеводів у порції їжі. За поширеними довідковими таблицями одна ХО дорівнює приблизно 10–12 г вуглеводів.",
    "what.p2": "Показник зручний тим, що дозволяє швидко порівнювати різні продукти за вмістом вуглеводів, не зважуючи щоразу все до грама. Люди використовують ХО як спрощений спосіб обліку вуглеводів у щоденному меню.",
    "what.p3": "Кількість ХО залежить і від самого продукту, і від його маси: що більше вуглеводів на 100 г і що більша порція — то більше хлібних одиниць. Універсальної схеми харчування, яка підходила б усім, не існує, тож питання раціону слід обговорювати з лікарем.",
    "what.more": "Ширшу довідкову інформацію про діабет і харчування зібрано на сайті — <a href=\"https://diabet-info.top/\" target=\"_blank\" rel=\"noopener\">diabet-info.top</a>.",

    "gi.h2": "Що таке глікемічний індекс (ГІ)?",
    "gi.p1": "Глікемічний індекс (ГІ) визначає швидкість, з якою вуглеводи, що містяться в певному продукті, здатні підвищувати концентрацію глюкози у крові, і цей показник порівнюється з впливом чистої глюкози (для якої ГІ дорівнює 100 одиницям). Якщо хлібні одиниці дають відповідь на запитання «яка кількість вуглеводів присутня в одній порції їжі», то глікемічний індекс розкриває інший аспект: «з якою швидкістю ці вуглеводи засвоюються організмом».",
    "gi.p2": "Продукти з низьким ГІ дають повільніше й рівномірніше підвищення глюкози, з високим — швидший стрибок. На остаточний вплив їжі впливають також кількість вуглеводів у порції, спосіб приготування, ступінь стиглості, вміст клітковини, білка та жиру.",
    "gi.p3": "У таблиці продуктів нижче колонка «ГІ» показує приблизний діапазон для кожного продукту, а калькулятор виводить ГІ обраного продукту поряд із результатом розрахунку ХО.",
    "gi.note": "Значення ГІ орієнтовні й помітно різняться між джерелами, сортами та способами приготування. Це інформаційний матеріал, він не замінює консультацію лікаря.",
    "gi.low": "низький",
    "gi.mid": "середній",
    "gi.high": "високий",
    "gi.low.desc": " — більшість овочів, бобові, більшість фруктів та ягід, молочні продукти, горіхи.",
    "gi.mid.desc": " — житній хліб, вівсянка, банан, ананас, родзинки, звичайне морозиво, мед.",
    "gi.high.desc": " — білий хліб, картопляне пюре, білий рис, кукурудзяні пластівці, кавун, солодка газована вода.",

    "table.h2": "Таблиця хлібних одиниць",
    "table.lead": "Орієнтовна кількість продукту, що містить одну хлібну одиницю, та вуглеводи на 100 г.",
    "table.search": "Пошук продукту…",
    "table.search.label": "Пошук продукту в таблиці",
    "table.filter.all": "Усі",
    "table.col.product": "Продукт",
    "table.col.amount": "Кількість на 1 ХО",
    "table.col.carbs": "Вуглеводи / 100 г",
    "table.col.gi": "ГІ",
    "table.empty": "Нічого не знайдено. Спробуйте інший запит.",
    "table.use": "У калькулятор",
    "table.expand": "Показати більше",
    "table.collapse": "Згорнути таблицю",
    "table.note": "*Значення в таблиці — приблизні довідкові цифри й можуть відрізнятися залежно від сорту та способу приготування продукту.",
    "table.gi.all": "Будь-який ГІ",
    "table.gi.label": "Фільтр за глікемічним індексом",
    "table.gi.note": "Колонка «ГІ» — приблизний глікемічний індекс: низький ≤ 55, середній 56–69, високий ≥ 70. «—» означає, що продукт майже не містить вуглеводів.",

    "cat.bakery": "Хліб і випічка",
    "cat.cereals": "Крупи",
    "cat.pasta": "Паста й картопля",
    "cat.veggies": "Овочі",
    "cat.legumes": "Бобові",
    "cat.fruits": "Фрукти та ягоди",
    "cat.juices": "Соки",
    "cat.dairy": "Молочні продукти",
    "cat.nuts": "Горіхи",
    "cat.fastfood": "Готові страви й фастфуд",
    "cat.other": "Інші продукти",

    "why.h2": "Проста робота з хлібними одиницями",
    "why.infographic.src": "/img/simple-bread-unit-calculation-ua.webp",
    "why.infographic.alt": "Проста робота з хлібними одиницями — інфографіка",

    "app.eyebrow": "Android-додаток",
    "app.h2": "Калькулятор хлібних одиниць",
    "app.text": "Калькулятор ХО в мобільному додатку.",
    "app.f1.title": "167 продуктів",
    "app.f1.text": "з вуглеводами та глікемічним індексом",
    "app.f2.title": "10 або 12 г",
    "app.f2.text": "норма на 1 ХО — як радить ваш лікар",
    "app.f3.title": "Без реєстрації",
    "app.f3.text": "дані залишаються на пристрої",
    "app.cta.small": "Завантажуйте в",
    "app.cta.aria": "Завантажити в Google Play",
    "app.mock.food": "Житній хліб",
    "app.mock.hint": "42 г вуглеводів у 100 г продукту",
    "app.banner.title": "Завантажити додаток",
    "app.banner.text": "Калькулятор хлібних одиниць для Android",
    "app.banner.aria": "Android-додаток",
    "app.banner.close": "Закрити",

    "faq.h2": "Поширені запитання",
    "faq.q1": "Що таке хлібна одиниця (ХО / XE)?",
    "faq.a1": "Це умовна міра для оцінки кількості вуглеводів у порції їжі. Одна ХО дорівнює приблизно 10–12 г вуглеводів за поширеними довідковими таблицями.",
    "faq.q2": "Як розраховується хлібна одиниця?",
    "faq.a2": "Калькулятор бере вуглеводи в 100 г продукту, множить на вагу порції, ділить на 100 і потім на обрану норму (10 або 12 г). Наприклад: (60 ÷ 100) × 40 ÷ 12 = 2.0 ХО.",
    "faq.q3": "Скільки грамів в одній хлібній одиниці?",
    "faq.a3": "Одна ХО — це приблизно 10–12 г вуглеводів. У грамах самого продукту це залежить від того, скільки вуглеводів у ньому міститься.",
    "faq.q4": "Чи можна рахувати ХО для різних продуктів?",
    "faq.a4": "Так. Оберіть потрібний продукт зі списку або введіть вміст вуглеводів вручну — формула однакова для будь-якого продукту.",
    "faq.q5": "Чи можна користуватися калькулятором на телефоні?",
    "faq.a5": "Так. Сайт адаптований під мобільні пристрої й працює в браузері смартфона, планшета чи комп’ютера.",
    "faq.q6": "Чи є Калькулятор хлібних одиниць медичним інструментом?",
    "faq.a6": "Ні. Це інформаційно-освітній інструмент, який виконує лише арифметичний розрахунок за введеними даними.",
    "faq.q7": "Чи може калькулятор замінити консультацію лікаря?",
    "faq.a7": "Ні. Результати є оцінними й не замінюють поради кваліфікованого медичного фахівця.",
    "faq.q8": "Чим глікемічний індекс відрізняється від хлібних одиниць?",
    "faq.a8": "Хлібні одиниці показують кількість вуглеводів у порції, а глікемічний індекс (ГІ) — наскільки швидко ці вуглеводи підвищують рівень глюкози в крові. Це доповнювальні показники: порція може мати однакову кількість ХО, але різний ГІ.",
    "faq.q9": "Як користуватися колонкою «ГІ» в таблиці?",
    "faq.a9": "Колонка показує приблизний глікемічний індекс: низький (≤ 55), середній (56–69) або високий (≥ 70). Значення орієнтовні й залежать від сорту та способу приготування. Продукти майже без вуглеводів позначені «—».",

    "disc.h2": "Важлива інформація",
    "disc.p1": "Цей калькулятор призначений винятково для інформаційного та навчального використання. Він не є медичним інструментом, а отже, не здатен діагностувати, лікувати або попереджати будь-які хвороби. Отримані результати мають орієнтовний характер і не повинні замінювати консультацію професійного лікаря.",
    "disc.p2": "Якщо у вас є запитання щодо харчування, рівня глюкози в крові, інсуліну чи ліків, зверніться до свого лікаря або іншого кваліфікованого медичного фахівця.",

    "footer.tagline": "Інформаційний калькулятор хлібних одиниць (ХО / XE).",
    "footer.nav": "Навігація",
    "footer.disclaimer": "Медичне застереження",
    "footer.rights": "Усі права захищені.",
    "footer.resources": "Ресурси",
    "footer.diabetInfo": "Про діабет — diabet-info.top",
    "footer.about": "Про сайт",
    "footer.contact": "Контакти",
    "footer.privacy": "Політика конфіденційності",
    "trust.reviewed": "Автор контенту",
    "trust.name": "Олег Кравчук",
    "trust.role": "Автор і редактор медичного контенту · Diabetes Calculator",
    "trust.bio": "Автор і редактор інформаційного проєкту <a href=\"https://diabet-info.top/\" target=\"_blank\" rel=\"noopener\">DiabetInfo</a>. Матеріали мають навчальний характер і регулярно перевіряються на доступність та відповідність зазначеним джерелам.",
    "trust.sources": "Джерела",
    "trust.sourcesLead": "Для довідкових матеріалів на цій сторінці використано такі авторитетні ресурси:",
    "trust.updated": "Оновлено: вересень 2026. Значення для продуктів є орієнтовними та можуть відрізнятися залежно від сорту й способу приготування."
  },

  en: {
    "meta.title": "Bread Units Calculator – Calculate BU Online",
    "meta.description": "Free online bread units (BU) calculator. Calculate bread units for food portions and browse a simple bread units food table.",

    "nav.calculator": "Calculator",
    "nav.how": "How It Works",
    "nav.gi": "Glycemic Index",
    "nav.table": "Food Table",
    "nav.faq": "FAQ",
    "nav.app": "Android app",
    "nav.skip": "To the calculator",
    "nav.menu": "Menu",

    "theme.toggle": "Toggle theme",
    "lang.label": "Language",

    "hero.eyebrow": "FREE ONLINE TOOL",
    "hero.h1": "Bread Units Calculator",
    "hero.subtitle": "Calculate bread units (BU) for food portions quickly and easily.",
    "hero.text": "Select a food or enter the carbohydrates manually, enter the portion weight, and get an estimated number of bread units.",
    "hero.cta1": "View Food Table",
    "hero.badge1": "No registration",
    "hero.badge2": "Runs in your browser",
    "hero.badge3": "Android app",

    "calc.title": "Bread Units Calculator",
    "calc.tab.food": "By food",
    "calc.tab.manual": "Manual",
    "calc.tab.aria": "Calculation mode",
    "calc.food": "Food / Product",
    "calc.food.placeholder": "Select a food from the list…",
    "calc.food.hint": "The selected food uses a reference carbohydrate value.",
    "calc.carbs": "Carbohydrates per 100 g",
    "calc.carbs.suffix": "g",
    "calc.weight": "Total portion weight",
    "calc.weight.suffix": "g / ml",
    "calc.norm": "1 BU equals",
    "calc.norm.10": "10 g",
    "calc.norm.12": "12 g",
    "calc.norm.aria": "1 BU = grams of carbohydrates",
    "calc.norm.hint": "Use 10 or 12 g of carbohydrates per bread unit.",
    "calc.calculate": "Calculate",
    "calc.reset": "Reset",
    "calc.result.caption": "Estimated bread units for this portion",
    "calc.result.unit": "BU",
    "calc.error.food": "Please select a food from the list.",
    "calc.error.carbs": "Enter carbohydrates between 1 and 100 g.",
    "calc.error.weight": "Enter a portion weight greater than zero.",
    "calc.formula": "({carbs} ÷ 100) × {weight} ÷ {norm} = {result} BU",
    "calc.gi.label": "Glycemic index of this food:",

    "how.h2": "How does the bread units calculator work?",
    "how.infographic.src": "/img/infographic-en.webp",
    "how.infographic.alt": "How the bread units calculator works — a four-step infographic",
    "how.example.title": "Example calculation",
    "how.example.body": "A <strong>40 g</strong> portion, with <strong>60 g of carbohydrates per 100 g</strong>, and 1 BU set to <strong>10–12 g</strong>: (60 ÷ 100) × 40 ÷ 12 = <strong>2.0 BU</strong>.",

    "what.h2": "What is a bread unit (BU)?",
    "what.p1": "A bread unit (BU, from the German “Broteinheit”), also called a carbohydrate exchange unit, is a rough measure for estimating the amount of digestible carbohydrates in a food portion. According to commonly used reference tables, one BU equals roughly 10–12 g of carbohydrates.",
    "what.p2": "The measure is convenient because it lets you quickly compare different foods by their carbohydrate content without weighing everything to the gram every time. People use BU as a simplified way to keep track of carbohydrates in their daily meals.",
    "what.p3": "The number of BU depends both on the food itself and on its weight: the more carbohydrates per 100 g and the larger the portion, the more bread units. There is no single eating plan that works for everyone, so diet questions should be discussed with a doctor.",
    "what.more": "Broader background information about diabetes and nutrition is collected on site — <a href=\"https://diabet-info.top/\" target=\"_blank\" rel=\"noopener\">diabet-info.top</a>.",

    "gi.h2": "What is the glycemic index (GI)?",
    "gi.p1": "The glycemic index (GI) describes how quickly the carbohydrates contained in a particular food can raise blood glucose concentration, measured against the effect of pure glucose (whose GI equals 100 units). While bread units answer the question “how much carbohydrate is in one portion of food”, the glycemic index reveals another aspect: “how quickly the body absorbs these carbohydrates”.",
    "gi.p2": "Low-GI foods produce a slower, more even rise in glucose; high-GI foods a faster spike. The final effect of a meal also depends on the amount of carbohydrate in the portion, the preparation method, ripeness, and the fibre, protein and fat content.",
    "gi.p3": "In the food table below, the “GI” column shows an approximate band for each food, and the calculator displays the GI of the selected food next to the BU result.",
    "gi.note": "GI values are approximate and vary noticeably between sources, varieties and preparation methods. This is informational material and does not replace medical advice.",
    "gi.low": "low",
    "gi.mid": "medium",
    "gi.high": "high",
    "gi.low.desc": " — most vegetables, legumes, most fruit and berries, dairy, nuts.",
    "gi.mid.desc": " — rye bread, oatmeal, banana, pineapple, raisins, regular ice cream, honey.",
    "gi.high.desc": " — white bread, mashed potato, white rice, cornflakes, watermelon, sugary soda.",

    "table.h2": "Bread Units Food Table",
    "table.lead": "Roughly how much of each food contains one bread unit, plus carbohydrates per 100 g.",
    "table.search": "Search food…",
    "table.search.label": "Search food in the table",
    "table.filter.all": "All",
    "table.col.product": "Product",
    "table.col.amount": "Amount for 1 BU",
    "table.col.carbs": "Carbs / 100 g",
    "table.col.gi": "GI",
    "table.empty": "Nothing found. Try a different search.",
    "table.use": "Use in calculator",
    "table.expand": "Show more",
    "table.collapse": "Show less",
    "table.note": "*The values in the table are approximate reference figures and can vary with the variety and preparation of the food.",
    "table.gi.all": "Any GI",
    "table.gi.label": "Filter by glycemic index",
    "table.gi.note": "The “GI” column is an approximate glycemic index: low ≤ 55, medium 56–69, high ≥ 70. “—” means the food contains almost no carbohydrate.",

    "cat.bakery": "Bread & Bakery",
    "cat.cereals": "Cereals",
    "cat.pasta": "Pasta & Potatoes",
    "cat.veggies": "Vegetables",
    "cat.legumes": "Legumes",
    "cat.fruits": "Fruits & Berries",
    "cat.juices": "Juices",
    "cat.dairy": "Dairy",
    "cat.nuts": "Nuts",
    "cat.fastfood": "Ready meals & fast food",
    "cat.other": "Other foods",

    "why.h2": "Simple bread unit calculation",
    "why.infographic.src": "/img/simple-bread-unit-calculation-en.webp",
    "why.infographic.alt": "Simple bread unit calculation — infographic",

    "app.eyebrow": "Android app",
    "app.h2": "Bread Units Calculator",
    "app.text": "BU calculator in a mobile app.",
    "app.f1.title": "167 foods",
    "app.f1.text": "with carbs and glycemic index",
    "app.f2.title": "10 or 12 g",
    "app.f2.text": "per 1 BU, as your doctor advises",
    "app.f3.title": "No sign-up",
    "app.f3.text": "your data stays on the device",
    "app.cta.small": "Get it on",
    "app.cta.aria": "Get it on Google Play",
    "app.mock.food": "Rye bread",
    "app.mock.hint": "42 g of carbs per 100 g of food",
    "app.banner.title": "Get the app",
    "app.banner.text": "Bread Units Calculator for Android",
    "app.banner.aria": "Android app",
    "app.banner.close": "Close",

    "faq.h2": "Frequently Asked Questions",
    "faq.q1": "What is a bread unit (BU)?",
    "faq.a1": "It is a rough measure for estimating the carbohydrates in a food portion. One BU equals roughly 10–12 g of carbohydrates according to common reference tables.",
    "faq.q2": "How is a bread unit calculated?",
    "faq.a2": "The calculator takes the carbohydrates per 100 g, multiplies by the portion weight, divides by 100 and then by your chosen grams-per-BU value (10 or 12 g). For example: (60 ÷ 100) × 40 ÷ 12 = 2.0 BU.",
    "faq.q3": "How many grams are one bread unit?",
    "faq.a3": "One BU is roughly 10–12 g of carbohydrates. In grams of the food itself it depends on how much carbohydrate that food contains.",
    "faq.q4": "Can I calculate BU for different foods?",
    "faq.a4": "Yes. Select the food from the list or enter the carbohydrate content manually — the formula is the same for any food.",
    "faq.q5": "Can I use the calculator on my phone?",
    "faq.a5": "Yes. The site is mobile friendly and works in the browser on a phone, tablet or desktop.",
    "faq.q6": "Is the Bread Units Calculator a medical tool?",
    "faq.a6": "No. It is an informational and educational tool that only performs an arithmetic calculation from the values you enter.",
    "faq.q7": "Can the calculator replace medical advice?",
    "faq.a7": "No. The results are estimates and do not replace advice from a qualified healthcare professional.",
    "faq.q8": "How does the glycemic index differ from bread units?",
    "faq.a8": "Bread units tell you how much carbohydrate is in a portion, while the glycemic index (GI) tells you how quickly that carbohydrate raises blood glucose. They are complementary: two portions can have the same BU but a different GI.",
    "faq.q9": "How do I use the “GI” column in the table?",
    "faq.a9": "The column shows an approximate glycemic index: low (≤ 55), medium (56–69) or high (≥ 70). The values are rough and depend on variety and preparation. Foods with almost no carbohydrate are marked “—”.",

    "disc.h2": "Important information",
    "disc.p1": "This calculator is intended exclusively for informational and educational use. It is not a medical tool and therefore cannot diagnose, treat or prevent any disease. The results obtained are approximate and should not replace a consultation with a professional doctor.",
    "disc.p2": "If you have questions about your diet, blood glucose management, insulin or medication, consult your doctor or another qualified healthcare professional.",

    "footer.tagline": "An informational bread units (BU) calculator.",
    "footer.nav": "Navigation",
    "footer.disclaimer": "Medical disclaimer",
    "footer.rights": "All rights reserved.",
    "footer.resources": "Resources",
    "footer.diabetInfo": "About diabetes — diabet-info.top",
    "footer.about": "About",
    "footer.contact": "Contact",
    "footer.privacy": "Privacy policy",
    "trust.reviewed": "Content author",
    "trust.name": "Oleg Kravchuk",
    "trust.role": "Author and medical content editor · Diabetes Calculator",
    "trust.bio": "Author and editor of the <a href=\"https://diabet-info.top/\" target=\"_blank\" rel=\"noopener\">DiabetInfo</a> information project. The materials are intended for learning and are regularly reviewed for readability and consistency with the stated sources.",
    "trust.sources": "Sources",
    "trust.sourcesLead": "The following authoritative resources were used for the reference material on this page:",
    "trust.updated": "Updated: September 2026. Food values are estimates and may differ by variety and preparation method."
  },

  es: {
    "meta.title": "Calculadora de Unidades de Pan (UP) en línea",
    "meta.description": "Calculadora gratuita de unidades de pan (UP) en línea. Calcula unidades de pan para porciones de alimentos y consulta una tabla sencilla de alimentos.",

    "nav.calculator": "Calculadora",
    "nav.how": "Cómo funciona",
    "nav.gi": "Índice glucémico",
    "nav.table": "Tabla de alimentos",
    "nav.faq": "Preguntas",
    "nav.app": "App para Android",
    "nav.skip": "A la calculadora",
    "nav.menu": "Menú",

    "theme.toggle": "Cambiar tema",
    "lang.label": "Idioma",

    "hero.eyebrow": "HERRAMIENTA GRATUITA EN LÍNEA",
    "hero.h1": "Calculadora de Unidades de Pan",
    "hero.subtitle": "Calcula unidades de pan (UP) para porciones de alimentos de forma rápida y sencilla.",
    "hero.text": "Elige un alimento o introduce los carbohidratos manualmente, indica el peso de la porción y obtén un número estimado de unidades de pan.",
    "hero.cta1": "Ver tabla de alimentos",
    "hero.badge1": "Sin registro",
    "hero.badge2": "Funciona en tu navegador",
    "hero.badge3": "App para Android",

    "calc.title": "Calculadora de Unidades de Pan",
    "calc.tab.food": "Por alimento",
    "calc.tab.manual": "Manual",
    "calc.tab.aria": "Modo de cálculo",
    "calc.food": "Alimento / Producto",
    "calc.food.placeholder": "Elige un alimento de la lista…",
    "calc.food.hint": "El alimento seleccionado usa un valor de carbohidratos de referencia.",
    "calc.carbs": "Carbohidratos por 100 g",
    "calc.carbs.suffix": "g",
    "calc.weight": "Peso total de la porción",
    "calc.weight.suffix": "g / ml",
    "calc.norm": "1 UP equivale a",
    "calc.norm.10": "10 g",
    "calc.norm.12": "12 g",
    "calc.norm.aria": "1 UP = gramos de carbohidratos",
    "calc.norm.hint": "Usa 10 o 12 g de carbohidratos por unidad de pan.",
    "calc.calculate": "Calcular",
    "calc.reset": "Restablecer",
    "calc.result.caption": "Unidades de pan estimadas para esta porción",
    "calc.result.unit": "UP",
    "calc.error.food": "Elige un alimento de la lista.",
    "calc.error.carbs": "Introduce carbohidratos entre 1 y 100 g.",
    "calc.error.weight": "Introduce un peso de porción mayor que cero.",
    "calc.formula": "({carbs} ÷ 100) × {weight} ÷ {norm} = {result} UP",
    "calc.gi.label": "Índice glucémico de este alimento:",

    "how.h2": "¿Cómo funciona la calculadora de unidades de pan?",
    "how.infographic.src": "/img/infographic-es.webp",
    "how.infographic.alt": "Cómo funciona la calculadora de unidades de pan — infografía de cuatro pasos",
    "how.example.title": "Ejemplo de cálculo",
    "how.example.body": "Una porción de <strong>40 g</strong>, con <strong>60 g de carbohidratos por 100 g</strong>, y 1 UP fijada en <strong>10–12 g</strong>: (60 ÷ 100) × 40 ÷ 12 = <strong>2.0 UP</strong>.",

    "what.h2": "¿Qué es una unidad de pan (UP)?",
    "what.p1": "Una unidad de pan (UP, del alemán «Broteinheit»), también llamada unidad de intercambio de carbohidratos, es una medida aproximada para estimar la cantidad de carbohidratos digeribles en una porción de alimento. Según las tablas de referencia habituales, una UP equivale aproximadamente a 10–12 g de carbohidratos.",
    "what.p2": "La medida es práctica porque permite comparar rápidamente distintos alimentos por su contenido de carbohidratos sin pesar todo al gramo cada vez. Muchas personas usan la UP como una forma simplificada de llevar la cuenta de los carbohidratos en su menú diario.",
    "what.p3": "El número de UP depende tanto del alimento como de su peso: cuantos más carbohidratos por 100 g y mayor sea la porción, más unidades de pan. No existe un único plan de alimentación válido para todo el mundo, por lo que las dudas sobre la dieta deben consultarse con un médico.",
    "what.more": "Encontrarás información general más amplia sobre la diabetes y la nutrición en un sitio web — <a href=\"https://diabet-info.top/\" target=\"_blank\" rel=\"noopener\">diabet-info.top</a>.",

    "gi.h2": "¿Qué es el índice glucémico (IG)?",
    "gi.p1": "El índice glucémico (IG) determina la rapidez con la que los carbohidratos de un alimento concreto pueden elevar la concentración de glucosa en sangre, y se compara con el efecto de la glucosa pura (cuyo IG equivale a 100 unidades). Si las unidades de pan responden a la pregunta «qué cantidad de carbohidratos hay en una porción de comida», el índice glucémico revela otro aspecto: «con qué rapidez absorbe el organismo esos carbohidratos».",
    "gi.p2": "Los alimentos de IG bajo producen una subida de glucosa más lenta y uniforme; los de IG alto, un pico más rápido. El efecto final de una comida también depende de la cantidad de carbohidratos de la porción, el método de preparación, la madurez y el contenido de fibra, proteína y grasa.",
    "gi.p3": "En la tabla de alimentos de abajo, la columna «IG» muestra un rango aproximado para cada alimento, y la calculadora muestra el IG del alimento seleccionado junto al resultado de UP.",
    "gi.note": "Los valores de IG son aproximados y varían notablemente entre fuentes, variedades y métodos de preparación. Es material informativo y no sustituye el consejo médico.",
    "gi.low": "bajo",
    "gi.mid": "medio",
    "gi.high": "alto",
    "gi.low.desc": " — la mayoría de verduras, legumbres, la mayoría de frutas y bayas, lácteos, frutos secos.",
    "gi.mid.desc": " — pan de centeno, avena, plátano, piña, pasas, helado normal, miel.",
    "gi.high.desc": " — pan blanco, puré de papa, arroz blanco, copos de maíz, sandía, refresco azucarado.",

    "table.h2": "Tabla de unidades de pan",
    "table.lead": "Cantidad aproximada de cada alimento que contiene una unidad de pan, y carbohidratos por 100 g.",
    "table.search": "Buscar alimento…",
    "table.search.label": "Buscar alimento en la tabla",
    "table.filter.all": "Todos",
    "table.col.product": "Producto",
    "table.col.amount": "Cantidad por 1 UP",
    "table.col.carbs": "Carb. / 100 g",
    "table.col.gi": "IG",
    "table.empty": "No se ha encontrado nada. Prueba otra búsqueda.",
    "table.use": "Usar en la calculadora",
    "table.expand": "Mostrar más",
    "table.collapse": "Mostrar menos",
    "table.note": "*Los valores de la tabla son cifras de referencia aproximadas y pueden variar según la variedad y la preparación del alimento.",
    "table.gi.all": "Cualquier IG",
    "table.gi.label": "Filtrar por índice glucémico",
    "table.gi.note": "La columna «IG» es un índice glucémico aproximado: bajo ≤ 55, medio 56–69, alto ≥ 70. «—» significa que el alimento casi no contiene carbohidratos.",

    "cat.bakery": "Pan y bollería",
    "cat.cereals": "Cereales",
    "cat.pasta": "Pasta y patatas",
    "cat.veggies": "Verduras",
    "cat.legumes": "Legumbres",
    "cat.fruits": "Frutas y bayas",
    "cat.juices": "Zumos",
    "cat.dairy": "Lácteos",
    "cat.nuts": "Frutos secos",
    "cat.fastfood": "Platos preparados y comida rápida",
    "cat.other": "Otros alimentos",

    "why.h2": "Cálculo sencillo de unidades de pan",
    "why.infographic.src": "/img/simple-bread-unit-calculation-es.webp",
    "why.infographic.alt": "Cálculo sencillo de unidades de pan — infografía",

    "app.eyebrow": "App para Android",
    "app.h2": "Calculadora de Unidades de Pan",
    "app.text": "Calculadora de UP en una app móvil.",
    "app.f1.title": "167 alimentos",
    "app.f1.text": "con carbohidratos e índice glucémico",
    "app.f2.title": "10 o 12 g",
    "app.f2.text": "por 1 UP, según te indique tu médico",
    "app.f3.title": "Sin registro",
    "app.f3.text": "tus datos se quedan en el dispositivo",
    "app.cta.small": "Disponible en",
    "app.cta.aria": "Disponible en Google Play",
    "app.mock.food": "Pan de centeno",
    "app.mock.hint": "42 g de carbohidratos por 100 g",
    "app.banner.title": "Descarga la app",
    "app.banner.text": "Calculadora de Unidades de Pan para Android",
    "app.banner.aria": "App para Android",
    "app.banner.close": "Cerrar",

    "faq.h2": "Preguntas frecuentes",
    "faq.q1": "¿Qué es una unidad de pan (UP)?",
    "faq.a1": "Es una medida aproximada para estimar los carbohidratos de una porción de alimento. Una UP equivale a unos 10–12 g de carbohidratos según las tablas de referencia habituales.",
    "faq.q2": "¿Cómo se calcula una unidad de pan?",
    "faq.a2": "La calculadora toma los carbohidratos por 100 g, los multiplica por el peso de la porción, divide entre 100 y luego entre el valor de 1 UP que elijas (10 o 12 g). Por ejemplo: (60 ÷ 100) × 40 ÷ 12 = 2.0 UP.",
    "faq.q3": "¿Cuántos gramos son una unidad de pan?",
    "faq.a3": "Una UP son unos 10–12 g de carbohidratos. En gramos del propio alimento depende de la cantidad de carbohidratos que contenga.",
    "faq.q4": "¿Puedo calcular las UP de distintos alimentos?",
    "faq.a4": "Sí. Elige el alimento en la lista o introduce el contenido de carbohidratos manualmente: la fórmula es la misma para cualquier alimento.",
    "faq.q5": "¿Puedo usar la calculadora en el teléfono?",
    "faq.a5": "Sí. El sitio es compatible con móviles y funciona en el navegador del teléfono, la tableta o el ordenador.",
    "faq.q6": "¿Es la Calculadora de Unidades de Pan una herramienta médica?",
    "faq.a6": "No. Es una herramienta informativa y educativa que solo realiza un cálculo aritmético con los valores que introduces.",
    "faq.q7": "¿Puede la calculadora sustituir el consejo médico?",
    "faq.a7": "No. Los resultados son estimaciones y no sustituyen el consejo de un profesional sanitario cualificado.",
    "faq.q8": "¿En qué se diferencia el índice glucémico de las unidades de pan?",
    "faq.a8": "Las unidades de pan indican cuántos carbohidratos hay en una porción, mientras que el índice glucémico (IG) indica con qué rapidez esos carbohidratos elevan la glucosa en sangre. Son complementarios: dos porciones pueden tener las mismas UP y un IG distinto.",
    "faq.q9": "¿Cómo se usa la columna «IG» de la tabla?",
    "faq.a9": "La columna muestra un índice glucémico aproximado: bajo (≤ 55), medio (56–69) o alto (≥ 70). Los valores son orientativos y dependen de la variedad y la preparación. Los alimentos casi sin carbohidratos se marcan con «—».",

    "disc.h2": "Información importante",
    "disc.p1": "Esta calculadora está destinada exclusivamente a un uso informativo y educativo. No es una herramienta médica y, por lo tanto, no puede diagnosticar, tratar ni prevenir ninguna enfermedad. Los resultados obtenidos son orientativos y no deben sustituir la consulta con un médico profesional.",
    "disc.p2": "Si tienes dudas sobre tu dieta, el control de la glucosa en sangre, la insulina o la medicación, consulta a tu médico o a otro profesional sanitario cualificado.",

    "footer.tagline": "Una calculadora informativa de unidades de pan (UP).",
    "footer.nav": "Navegación",
    "footer.disclaimer": "Aviso médico",
    "footer.rights": "Todos los derechos reservados.",
    "footer.resources": "Recursos",
    "footer.diabetInfo": "Sobre la diabetes — diabet-info.top",
    "footer.about": "Acerca del sitio",
    "footer.contact": "Contacto",
    "footer.privacy": "Política de privacidad",
    "trust.reviewed": "Autor del contenido",
    "trust.name": "Oleg Kravchuk",
    "trust.role": "Autor y editor de contenido médico · Diabetes Calculator",
    "trust.bio": "Autor y editor del proyecto informativo <a href=\"https://diabet-info.top/\" target=\"_blank\" rel=\"noopener\">DiabetInfo</a>. Los materiales tienen carácter didáctico y se revisan periódicamente para garantizar su facilidad de lectura y su coherencia con las fuentes indicadas.",
    "trust.sources": "Fuentes",
    "trust.sourcesLead": "Para el material de referencia de esta página se utilizaron los siguientes recursos autorizados:",
    "trust.updated": "Actualizado: septiembre de 2026. Los valores de los alimentos son estimaciones y pueden variar según la variedad y el método de preparación."
  }
};

/* Bread Units Calculator - app logic (vanilla JS, no dependencies).
   Bundled by gulp: foods.js + i18n.js + main.js -> build/js/scripts.min.js */
(function () {
  "use strict";

  var LANGS = ["uk", "en", "es"];
  var DEFAULT_LANG = "uk";
  var TABLE_PREVIEW_ROWS = 8;        // rows shown before "show more" on desktop
  var TABLE_PREVIEW_ROWS_MOBILE = 3; // ... and on small screens
  var TABLE_EXPAND_STEP = 8;         // each "show more" click reveals this many extra rows
  var MOBILE_MQ = window.matchMedia
    ? window.matchMedia("(max-width: 640px)")
    : { matches: false, addEventListener: function () {}, addListener: function () {} };
  function tablePreviewRows() { return MOBILE_MQ.matches ? TABLE_PREVIEW_ROWS_MOBILE : TABLE_PREVIEW_ROWS; }
  var I18N = window.BUC_I18N || {};
  var FOODS = window.BUC_FOODS || [];
  var CATS = ["bakery", "cereals", "pasta", "veggies", "legumes", "fruits", "juices", "dairy", "nuts", "fastfood", "other"];

  var state = {
    lang: DEFAULT_LANG,
    theme: "light",
    norm: 12, // grams of carbohydrates per 1 XE - original calculator used 10 or 12
    mode: "food", // "food" = pick from list, "manual" = type carbs per 100 g
    tableLimit: null // null = show the initial preview; otherwise the max rows to render
  };

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function t(key) {
    var d = I18N[state.lang] || I18N[DEFAULT_LANG] || {};
    if (key in d) return d[key];
    return (I18N[DEFAULT_LANG] && I18N[DEFAULT_LANG][key]) || key;
  }
  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function num(v) { return parseFloat(String(v == null ? "" : v).replace(",", ".")); }

  /* ---------------- i18n ---------------- */
  function applyI18n() {
    document.documentElement.lang = state.lang;

    $all("[data-i18n]").forEach(function (el) { el.textContent = t(el.getAttribute("data-i18n")); });
    $all("[data-i18n-html]").forEach(function (el) { el.innerHTML = t(el.getAttribute("data-i18n-html")); });
    $all("[data-i18n-attr]").forEach(function (el) {
      el.getAttribute("data-i18n-attr").split(",").forEach(function (pair) {
        var p = pair.split(":");
        if (p.length === 2) el.setAttribute(p[0].trim(), t(p[1].trim()));
      });
    });

    updateLangSwitch();

    // Pages without the calculator (legal / static pages) keep their own
    // static SEO <title> and meta description in the document head.
    if (!$("#calculator")) return;

    document.title = t("meta.title");
    setMeta('meta[name="description"]', "content", t("meta.description"));
    setMeta('meta[property="og:title"]', "content", t("meta.title"));
    setMeta('meta[property="og:description"]', "content", t("meta.description"));
    setMeta('meta[property="og:locale"]', "content", { uk: "uk_UA", en: "en_US", es: "es_ES" }[state.lang]);

    rebuildFoodOptions();
    rebuildTable();
  }
  function setMeta(sel, attr, val) { var el = $(sel); if (el && val) el.setAttribute(attr, val); }

  /* ---------------- language switch (custom listbox) ---------------- */
  function langCode(lang) { return lang === "uk" ? "UA" : lang.toUpperCase(); }

  function updateLangSwitch() {
    var wrap = $("#lang-switch");
    if (!wrap) return;
    var current = null;
    $all(".lang-switch__option", wrap).forEach(function (o) {
      var sel = o.getAttribute("data-lang") === state.lang;
      o.setAttribute("aria-selected", sel ? "true" : "false");
      if (sel) current = o;
    });
    if (!current) return;
    var flag = $("#lang-current-flag");
    var srcFlag = $(".lang-switch__flag", current);
    if (flag && srcFlag) flag.innerHTML = srcFlag.innerHTML;
    var code = $("#lang-current-code");
    if (code) code.textContent = langCode(state.lang);
  }

  function initLangSwitch() {
    var wrap = $("#lang-switch");
    if (!wrap) return;
    var toggle = $("#lang-toggle", wrap);
    var menu = $("#lang-menu", wrap);
    var opts = $all(".lang-switch__option", wrap);
    if (!toggle || !menu || !opts.length) return;

    function isOpen() { return wrap.classList.contains("is-open"); }

    function onDocPointer(e) { if (!wrap.contains(e.target)) close(false); }
    function onKey(e) {
      if (!isOpen()) return;
      var i = opts.indexOf(document.activeElement);
      switch (e.key) {
        case "Escape": e.preventDefault(); close(true); break;
        case "ArrowDown": e.preventDefault(); (opts[i + 1] || opts[0]).focus(); break;
        case "ArrowUp": e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); break;
        case "Home": e.preventDefault(); opts[0].focus(); break;
        case "End": e.preventDefault(); opts[opts.length - 1].focus(); break;
        case "Tab": close(false); break;
      }
    }

    function open() {
      wrap.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      var sel = opts.filter(function (o) { return o.getAttribute("aria-selected") === "true"; })[0] || opts[0];
      sel.focus();
      document.addEventListener("pointerdown", onDocPointer, true);
      document.addEventListener("keydown", onKey, true);
    }
    function close(focusToggle) {
      if (!isOpen()) { if (focusToggle) toggle.focus(); return; }
      wrap.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.removeEventListener("pointerdown", onDocPointer, true);
      document.removeEventListener("keydown", onKey, true);
      if (focusToggle) toggle.focus();
    }
    function choose(o) {
      var lang = o.getAttribute("data-lang");
      close(true);
      if (lang && lang !== state.lang) setLang(lang);
    }

    toggle.addEventListener("click", function () { isOpen() ? close(false) : open(); });
    opts.forEach(function (o) {
      o.addEventListener("click", function () { choose(o); });
      o.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") { e.preventDefault(); choose(o); }
      });
    });
  }

  // Language lives in the URL path: "/" (uk) or "/en/", "/es/" as the first
  // segment, either flat ("/en/") or nested ("/en/about/").
  function detectLangFromPath() {
    var seg = window.location.pathname.replace(/index\.html$/, "").replace(/\/+$/, "").split("/").filter(Boolean)[0];
    return (seg === "en" || seg === "es") ? seg : DEFAULT_LANG;
  }
  function urlForLang(lang) {
    var path = window.location.pathname.replace(/index\.html$/, "").replace(/\/+$/, "");
    var segs = path.split("/").filter(Boolean);
    var rest = (segs[0] === "en" || segs[0] === "es") ? segs.slice(1) : segs;
    var out = (lang === DEFAULT_LANG ? [] : [lang]).concat(rest).join("/");
    return "/" + (out ? out + "/" : "");
  }
  function setLang(lang) {
    if (LANGS.indexOf(lang) === -1 || lang === state.lang) return;
    window.location.href = urlForLang(lang) + window.location.hash;
  }

  /* ---------------- theme ---------------- */
  function applyTheme() {
    document.documentElement.setAttribute("data-theme", state.theme);
    var b = $("#theme-toggle");
    if (b) b.setAttribute("aria-pressed", state.theme === "dark" ? "true" : "false");
  }
  function setTheme(theme) {
    state.theme = theme === "dark" ? "dark" : "light";
    store("buc-theme", state.theme);
    applyTheme();
  }

  /* ---------------- food select ---------------- */
  function foodName(f) { return (f.name && (f.name[state.lang] || f.name.en)) || f.id; }

  function rebuildFoodOptions() {
    var select = $("#calc-food");
    if (!select) return;
    var current = select.value;
    select.innerHTML = "";

    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent = t("calc.food.placeholder");
    select.appendChild(ph);

    CATS.forEach(function (cat) {
      var items = FOODS.filter(function (f) { return f.cat === cat; });
      if (!items.length) return;
      var g = document.createElement("optgroup");
      g.label = t("cat." + cat);
      items.sort(function (a, b) { return foodName(a).localeCompare(foodName(b), state.lang); });
      items.forEach(function (f) {
        var o = document.createElement("option");
        o.value = f.id;
        o.textContent = foodName(f);
        g.appendChild(o);
      });
      select.appendChild(g);
    });

    if (current && FOODS.some(function (f) { return f.id === current; })) select.value = current;
  }

  function getFood(id) {
    return FOODS.filter(function (f) { return f.id === id; })[0] || null;
  }

  /* ---------------- calculation ----------------
   * Original project formula, unchanged:
   *     XE = (carbsPer100 / 100) * portionWeight / norm
   */
  function computeXE(carbsPer100, weight, norm) {
    return (carbsPer100 / 100) * weight / norm;
  }

  function fmt(n) { return n.toFixed(1); }
  function round1(n) { return Math.round(n * 10) / 10; }

  var animId = null;
  function animateResult(target) {
    var el = $("#calc-result-value");
    if (!el) return;
    if (animId) cancelAnimationFrame(animId);
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { el.textContent = fmt(target); return; }
    var start = performance.now();
    var from = parseFloat(el.textContent) || 0;
    var dur = 450;
    function step(now) {
      var p = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(from + (target - from) * e);
      if (p < 1) animId = requestAnimationFrame(step);
    }
    animId = requestAnimationFrame(step);
  }

  function showError(msg) {
    var box = $("#calc-error");
    if (!box) return;
    box.textContent = msg || "";
    box.hidden = !msg;
  }

  // carbs per 100 g for the current mode (from the food list, or typed manually)
  function currentInputs() {
    var weight = num(($("#calc-weight") || {}).value);
    var carbs;
    if (state.mode === "food") {
      var f = getFood((($("#calc-food") || {}).value));
      carbs = f ? f.carbs : NaN;
    } else {
      carbs = num(($("#calc-carbs") || {}).value);
    }
    return { carbs: carbs, weight: weight };
  }

  function inputsValid(v) {
    return !isNaN(v.carbs) && v.carbs >= 1 && v.carbs <= 100 && !isNaN(v.weight) && v.weight > 0;
  }

  function calculate() {
    var v = currentInputs();

    if (state.mode === "food" && !getFood((($("#calc-food") || {}).value))) {
      showError(t("calc.error.food")); return;
    }
    if (isNaN(v.carbs) || v.carbs < 1 || v.carbs > 100) { showError(t("calc.error.carbs")); return; }
    if (isNaN(v.weight) || v.weight <= 0) { showError(t("calc.error.weight")); return; }
    showError("");

    var xe = computeXE(v.carbs, v.weight, state.norm);
    if (!isFinite(xe)) return;

    var card = $("#calc-result");
    card.classList.remove("is-empty");
    card.classList.add("is-active", "pop");
    setTimeout(function () { card.classList.remove("pop"); }, 320);
    animateResult(xe);

    var f = $("#calc-formula");
    f.textContent = t("calc.formula")
      .replace("{carbs}", round1(v.carbs))
      .replace("{weight}", round1(v.weight))
      .replace("{norm}", state.norm)
      .replace("{result}", fmt(xe));
    f.hidden = false;

    showGiForSelectedFood();
  }

  // GI note under the result, shown only when a listed food with a GI is selected
  function showGiForSelectedFood() {
    var el = $("#calc-gi");
    if (!el) return;
    var food = state.mode === "food" ? getFood((($("#calc-food") || {}).value)) : null;
    var band = food ? giBand(food.gi) : null;
    if (!band) { el.hidden = true; return; }
    el.className = "result__gi result__gi--" + band;
    el.textContent = t("calc.gi.label") + " " + food.gi + " · " + t("gi." + band);
    el.hidden = false;
  }

  function recalcIfActive() {
    if ($("#calc-result") && $("#calc-result").classList.contains("is-active") && inputsValid(currentInputs())) {
      calculate();
    }
  }

  function setMode(mode, focus) {
    state.mode = mode === "manual" ? "manual" : "food";
    store("buc-mode", state.mode);
    var card = $("#calculator");
    if (card) card.setAttribute("data-mode", state.mode);

    $all("[data-calc-tab]").forEach(function (b) {
      var active = b.getAttribute("data-calc-tab") === state.mode;
      b.classList.toggle("is-active", active);
      b.setAttribute("aria-selected", active ? "true" : "false");
      b.tabIndex = active ? 0 : -1;
      if (active && focus) b.focus();
    });

    // carry the value across: fill the manual field from the selected food
    if (state.mode === "manual") {
      var f = getFood((($("#calc-food") || {}).value));
      var c = $("#calc-carbs");
      if (f && c && !num(c.value)) c.value = f.carbs;
    }

    showError("");
    recalcIfActive();
  }

  function resetCalc() {
    ["#calc-food", "#calc-carbs", "#calc-weight"].forEach(function (s) { var el = $(s); if (el) el.value = ""; });
    showError("");
    var card = $("#calc-result");
    if (card) { card.classList.add("is-empty"); card.classList.remove("is-active"); }
    var val = $("#calc-result-value"); if (val) val.textContent = "0.0";
    var f = $("#calc-formula"); if (f) f.hidden = true;
    var gi = $("#calc-gi"); if (gi) gi.hidden = true;
    var food = $("#calc-food"); if (food) food.focus();
  }

  /* ---------------- food table ---------------- */
  function amountFor1XE(food) {
    // grams (or ml) of this food that contain one XE, at the current norm
    return Math.round((state.norm * 100) / food.carbs);
  }

  /* ---------------- glycemic index ---------------- */
  // band for a numeric GI: "low" (<=55) | "mid" (56-69) | "high" (>=70) | null
  function giBand(gi) {
    if (gi == null || isNaN(gi)) return null;
    if (gi <= 55) return "low";
    if (gi <= 69) return "mid";
    return "high";
  }
  // coloured pill for the food table; "—" when GI is not meaningful
  function giBadge(f) {
    var band = giBand(f.gi);
    if (!band) return '<span class="gi-badge gi-badge--na">—</span>';
    return '<span class="gi-badge gi-badge--' + band + '" title="' + f.gi + " · " + t("gi." + band) + '">' +
      f.gi + '<span class="visually-hidden"> — ' + t("gi." + band) + "</span></span>";
  }

  // rows for the current category filter + search query, sorted for display
  function currentTableRows() {
    var q = (($("#table-search") || {}).value || "").trim().toLowerCase();
    var active = $(".table-filter .is-active");
    var cat = active ? active.getAttribute("data-cat") : "all";
    var giActive = $(".table-gi-filter .is-active");
    var giKey = giActive ? giActive.getAttribute("data-gi") : "all";
    return FOODS
      .filter(function (f) { return cat === "all" || f.cat === cat; })
      .filter(function (f) { return giKey === "all" || giBand(f.gi) === giKey; })
      .filter(function (f) {
        if (!q) return true;
        return LANGS.some(function (l) { return (f.name[l] || "").toLowerCase().indexOf(q) > -1; });
      })
      .sort(function (a, b) {
        if (a.cat !== b.cat) return CATS.indexOf(a.cat) - CATS.indexOf(b.cat);
        return foodName(a).localeCompare(foodName(b), state.lang);
      });
  }

  function rebuildTable() {
    var tbody = $("#food-tbody");
    if (!tbody) return;

    var rows = currentTableRows();

    var preview = tablePreviewRows();
    // how many rows are visible right now: the preview, or the accumulated limit
    var visible = Math.min(state.tableLimit == null ? preview : state.tableLimit, rows.length);
    var allShown = visible >= rows.length;
    var toggle = $("#table-toggle");
    var toggleWrap = toggle ? toggle.parentElement : null;
    var isExpandable = rows.length > preview;
    if (toggleWrap) toggleWrap.hidden = !isExpandable;
    if (toggle) {
      var key = allShown ? "table.collapse" : "table.expand";
      toggle.setAttribute("aria-expanded", allShown ? "true" : "false");
      toggle.setAttribute("data-i18n", key);
      toggle.textContent = t(key);
    }

    tbody.innerHTML = "";
    if (!rows.length) {
      var tr = document.createElement("tr");
      tr.innerHTML = '<td colspan="5" class="food-table__empty">' + t("table.empty") + "</td>";
      tbody.appendChild(tr);
      return;
    }

    rows.slice(0, visible).forEach(function (f) {
      var unit = f.liquid ? t("calc.weight.suffix").split("/")[1].trim() : t("calc.carbs.suffix");
      var tr = document.createElement("tr");
      tr.innerHTML =
        '<td data-label="' + t("table.col.product") + '"><span class="food-table__cat">' + t("cat." + f.cat) + "</span>" + foodName(f) + "</td>" +
        '<td data-label="' + t("table.col.amount") + '">' + amountFor1XE(f) + " " + unit + "</td>" +
        '<td data-label="' + t("table.col.carbs") + '">' + f.carbs + " " + t("calc.carbs.suffix") + "</td>" +
        '<td data-label="' + t("table.col.gi") + '">' + giBadge(f) + "</td>" +
        '<td class="food-table__action"><button type="button" class="link-btn" data-use="' + f.id + '">' + t("table.use") + "</button></td>";
      tbody.appendChild(tr);
    });
  }

  // build a row of single-select filter chips inside `selector`
  function buildFilterChips(selector, attr, entries) {
    var wrap = $(selector);
    if (!wrap) return;
    wrap.innerHTML = "";
    entries.forEach(function (e, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "chip";
      b.setAttribute(attr, e.key);
      b.textContent = e.label;
      if (i === 0) b.classList.add("is-active");
      b.addEventListener("click", function () {
        $all(".chip", wrap).forEach(function (c) { c.classList.remove("is-active"); });
        b.classList.add("is-active");
        state.tableLimit = null;
        rebuildTable();
      });
      wrap.appendChild(b);
    });
  }

  function buildTableFilters() {
    buildFilterChips(".table-filter", "data-cat",
      [{ key: "all", label: t("table.filter.all") }].concat(
        CATS.map(function (c) { return { key: c, label: t("cat." + c) }; })));

    buildFilterChips(".table-gi-filter", "data-gi", [
      { key: "all", label: t("table.gi.all") },
      { key: "low", label: t("gi.low") },
      { key: "mid", label: t("gi.mid") },
      { key: "high", label: t("gi.high") }
    ]);
  }

  function useFoodInCalculator(id) {
    var food = getFood(id);
    if (!food) return;
    var select = $("#calc-food"); if (select) select.value = id;
    var carbs = $("#calc-carbs"); if (carbs) carbs.value = food.carbs;
    var weight = $("#calc-weight");
    if (weight && !num(weight.value)) weight.value = food.piece || 100;
    calculate();
    var calc = document.getElementById("calculator");
    if (calc) calc.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* ---------------- nav ---------------- */
  function initMenu() {
    var toggle = $(".nav__toggle");
    var menu = $("#primary-nav");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("nav-locked", open);
    });
    menu.addEventListener("click", function (e) {
      if (e.target.closest("a")) {
        menu.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        document.body.classList.remove("nav-locked");
      }
    });
    window.addEventListener("resize", function () {
      if (window.innerWidth > 800 && menu.classList.contains("is-open")) {
        menu.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
        document.body.classList.remove("nav-locked");
      }
    });
  }

  /* ---------------- scroll reveal ---------------- */
  function initReveal() {
    var els = $all("[data-reveal]");
    if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.unobserve(entry.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- floating "back to calculator" ---------------- */
  function initBackToCalc() {
    var link = $(".skip-link");
    var calc = $("#calculator");
    if (!link || !calc || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // show once the calculator has been scrolled up out of view
      link.classList.toggle("is-visible", !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(calc);
  }

  /* ---------------- bottom "get the app" bar ---------------- */
  var APP_BANNER_KEY = "buc-app-banner";
  var APP_BANNER_DELAY = 3200;

  function initAppBanner() {
    var bar = $("#app-banner");
    if (!bar || read(APP_BANNER_KEY) === "closed") return;

    // Reserve space under the footer so the bar never covers its last line.
    function syncPadding() {
      document.body.style.paddingBottom = bar.classList.contains("is-open") ? bar.offsetHeight + "px" : "";
    }

    function close() {
      store(APP_BANNER_KEY, "closed");
      bar.classList.remove("is-open");
      syncPadding();
      var done = function () { bar.hidden = true; };
      bar.addEventListener("transitionend", done, { once: true });
      setTimeout(done, 700); // fallback when transitions are disabled
    }

    setTimeout(function () {
      bar.hidden = false;
      // next frame, so the slide-in transition starts from the hidden state
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.classList.add("is-open");
          syncPadding();
        });
      });
    }, APP_BANNER_DELAY);

    $("#app-banner-close").addEventListener("click", close);
    // Going to the store counts as "seen" — don't nag afterwards.
    $("#app-banner-link").addEventListener("click", close);
    window.addEventListener("resize", syncPadding);
  }

  /* ---------------- init ---------------- */
  function init() {
    var savedTheme = read("buc-theme");
    if (savedTheme) state.theme = savedTheme;
    else if (window.matchMedia("(prefers-color-scheme: dark)").matches) state.theme = "dark";
    applyTheme();

    state.lang = detectLangFromPath();
    $all("a.brand").forEach(function (a) { a.setAttribute("href", urlForLang(state.lang)); });

    var savedNorm = parseInt(read("buc-norm"), 10);
    if (savedNorm === 10 || savedNorm === 12) state.norm = savedNorm;

    var savedMode = read("buc-mode");
    state.mode = savedMode === "manual" ? "manual" : "food";

    var themeBtn = $("#theme-toggle");
    if (themeBtn) themeBtn.addEventListener("click", function () {
      setTheme(state.theme === "dark" ? "light" : "dark");
      rebuildTable();
    });

    initLangSwitch();

    $all("[data-set-norm]").forEach(function (btn) {
      var n = parseInt(btn.getAttribute("data-set-norm"), 10) === 10 ? 10 : 12;
      if (n === state.norm) { btn.classList.add("is-active"); btn.setAttribute("aria-pressed", "true"); }
      btn.addEventListener("click", function () {
        state.norm = n;
        store("buc-norm", String(n));
        $all("[data-set-norm]").forEach(function (b) {
          var active = b === btn;
          b.classList.toggle("is-active", active);
          b.setAttribute("aria-pressed", active ? "true" : "false");
        });
        rebuildTable();
        recalcIfActive();
      });
    });

    var tablist = $(".calc-tabs");
    if (tablist) {
      var tabs = $all("[data-calc-tab]", tablist);
      tabs.forEach(function (btn) {
        btn.addEventListener("click", function () { setMode(btn.getAttribute("data-calc-tab")); });
        btn.addEventListener("keydown", function (e) {
          var i = tabs.indexOf(btn);
          if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            e.preventDefault();
            var next = tabs[(i + (e.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length];
            setMode(next.getAttribute("data-calc-tab"), true);
          }
        });
      });
    }
    setMode(state.mode);

    var food = $("#calc-food");
    if (food) food.addEventListener("change", function () {
      showError("");
      recalcIfActive();
    });

    var form = $("#calc-form");
    if (form) form.addEventListener("submit", function (e) { e.preventDefault(); calculate(); });
    var resetBtn = $("#calc-reset");
    if (resetBtn) resetBtn.addEventListener("click", resetCalc);

    // carbohydrates per 100 g: keep within 1-100
    var carbsEl = $("#calc-carbs");
    if (carbsEl) carbsEl.addEventListener("input", function () {
      var n = num(carbsEl.value);
      if (!isNaN(n) && n > 100) carbsEl.value = "100";
      recalcIfActive();
    });

    // portion weight: digits only, at most 4
    var weightEl = $("#calc-weight");
    if (weightEl) weightEl.addEventListener("input", function () {
      var trimmed = weightEl.value.replace(/\D/g, "").slice(0, 4);
      if (weightEl.value !== trimmed) weightEl.value = trimmed;
      recalcIfActive();
    });

    var search = $("#table-search");
    if (search) search.addEventListener("input", function () {
      state.tableLimit = null;
      rebuildTable();
    });

    var tableToggle = $("#table-toggle");
    if (tableToggle) tableToggle.addEventListener("click", function () {
      var total = currentTableRows().length;
      var current = state.tableLimit == null ? tablePreviewRows() : state.tableLimit;
      // reveal TABLE_EXPAND_STEP more rows, or collapse back once everything is visible
      state.tableLimit = current >= total ? null : current + TABLE_EXPAND_STEP;
      rebuildTable();
    });

    // re-render the table when crossing the mobile breakpoint (preview 3 <-> 8)
    var onMqChange = function () { rebuildTable(); };
    if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener("change", onMqChange);
    else if (MOBILE_MQ.addListener) MOBILE_MQ.addListener(onMqChange);

    var tbody = $("#food-tbody");
    if (tbody) tbody.addEventListener("click", function (e) {
      var b = e.target.closest("[data-use]");
      if (b) useFoodInCalculator(b.getAttribute("data-use"));
    });

    buildTableFilters();
    initMenu();
    initReveal();
    initBackToCalc();
    initAppBanner();
    applyI18n();

    var y = $("#year");
    if (y) y.textContent = new Date().getFullYear();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

